var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 25,
    rx: 24.5,
    ry: 25,
    fill: "#C26900",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7208 15.3236C36.6047 15.2313 36.4696 15.1672 36.3257 15.1362C36.1818 15.1051 36.0328 15.1079 35.8901 15.1444L28.4876 17.0325L21.0585 13.2415C20.8515 13.1362 20.6144 13.1099 20.3901 13.1674L12.6401 15.1444C12.4305 15.1979 12.2444 15.3213 12.1115 15.495C11.9785 15.6687 11.9063 15.8828 11.9062 16.1033V33.8966C11.9063 34.0468 11.9398 34.1951 12.0044 34.3301C12.069 34.465 12.1628 34.5832 12.2789 34.6757C12.3949 34.7681 12.53 34.8323 12.674 34.8635C12.818 34.8947 12.9671 34.8919 13.1099 34.8555L20.5124 32.9674L27.9415 36.7584C28.0764 36.8262 28.2246 36.8617 28.375 36.8622C28.4542 36.8621 28.5331 36.8522 28.6099 36.8325L36.3599 34.8555C36.5695 34.802 36.7556 34.6786 36.8885 34.5049C37.0215 34.3312 37.0937 34.1171 37.0938 33.8966V16.1033C37.0938 15.9529 37.0602 15.8046 36.9956 15.6694C36.9309 15.5343 36.837 15.416 36.7208 15.3236ZM21.5938 15.7252L27.4062 18.6907V34.2747L21.5938 31.3092V15.7252ZM13.8438 16.8756L19.6562 15.3928V31.1473L13.8438 32.6301V16.8756ZM35.1562 33.1244L29.3438 34.6071V18.8526L35.1562 17.3698V33.1244Z",
    fill: "#C26900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.8c29f68f0f38d5a9030f7a7e64253461.svg";
export { ForwardRef as ReactComponent };